/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/6
 * Time: 16:28
 * Desc: 分销商品管理
 */

import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { appEnvConfig } from '@/configs/appConfigs';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import { EmpServiceAPIActions } from '@/services/empService';
import baseAPIService from '@/services/base/baseAPIService';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import ExportFile from '@/views/components/exportFile';
@Component({
  components: {
    NoAuth,
    ExportFile,
  },
})
export default class DistributeManage extends Vue {
  /* 数据 */

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 商品列表
   * @type {Array<GoodsList>}
   */
  public goodsList: Array<GoodsList> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中活动
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 图片放大弹窗是否显示
   * @type {boolean}
   */
  public isMagnifyPopShow = false;

  /**
   * 当前选中的图片
   * @type {string}
   */
  public curPic = '';

  /**
   * 错误图片
   */
  public errorImg: any = require('../../../../static/img/boxBgImg.svg');

  /**
   * 已选中的商品列表
   * @type {Array<GoodsList>}
   */
  public selectedList: Array<GoodsList> = [];

  /**
   *  导出按钮的信息
   * @type {ItemObject}
   */
  public exportBtnInfo: ItemObject = {
    state: 0,
    url: '',
  };

  /**
   * 导入弹窗是否显示
   * @type {boolean}
   */
  public isImportPopShow = false;

  /**
   * 要导入的文件名
   * @type {string}
   */
  public fileName = '';

  /**
   * 导入状态
   * @type {number}
   */
  public importState = 0; // 0,未导入 1,导入中 2,导入完成

  /**
   * token
   * @type {{string}}
   */
  public tokenData = `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`;

  /**
   * 导入成功的条数
   * @type {string}
   */
  public successNum: any = '0';

  /**
   * 导入失败的条数
   * @type {string}
   */
  public failedNum: any = '0';

  /**
   * 导入总的条数
   * @type {string}
   */
  public totalNum: any = '0';

  /**
   * 要上传的文件
   * @type {null}
   */
  public files: any = null;

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public failResultFileURl = '';

  /**
   * 是否正在准备导入
   * @type {boolean}
   */
  public isImportPrepare = true;

  /**
   * socket连接准备
   * @type {boolean}
   */
  public isSocketReady = false;

  /* 方法 */

  /**
   * 获取分销商品列表
   * @return null
   */
  public onSearchGoods(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getGoodsList();
  }

  /**
   * 条数变更
   * @type {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getGoodsList();
  }

  /**
   * 页码变更
   * @type {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getGoodsList();
  }

  /**
   * 选中的活动
   * @param val
   */
  public handleSelectionChange(val): void {
    this.isSelected = val.length > 0;
    this.selectedList = val;
  }

  /**
   * 获取商品列表
   * @return null
   */
  public getGoodsList(): void {
    this.goodsList = [];
    const queryParams = {
      page: this.page,
      pageSize: this.pageSize,
      keywords: this.keywords,
    };
    IPSService.guiderProductCommissionList({ queryParams }).then((res) => {
      // 格式化数据
      if (res.list.length > 0) {
        res.list.forEach((item) => {
          item.updateTime = Functions.emptyVaribleHandler(item.updateTime);
          item.goodsName = Functions.emptyVaribleHandler(item.goodsName);
          item.commission = item.commission ? item.commission.toFixed(2) : 0;
          item.updatePerson = Functions.emptyVaribleHandler(item.updatePerson);
        });
      }
      this.goodsList = res.list;
      this.totalCount = res.count;
    });
  }

  /**
   * 图片放大弹窗
   * @param {string} pic
   * @return null
   */
  public onMagnifyClassPic(pic: string): void {
    this.curPic = pic;
    this.isMagnifyPopShow = true;
  }

  /**
   * 重新格式化图片地址
   * @param {ItemObject} item
   */
  public reCreateImgSrc(item: ItemObject): void {
    item.iconSrc = this.errorImg;
  }

  /**
   * 分销商品佣金保存
   * @param {GoodsList} item
   * @return null
   */
  public onSaveCommission(item: GoodsList): void {
    if (Number.isNaN(item.commission * 1)) {
      this.$message.error('请输入数字');
    } else if (item.commission < 0) {
      this.$message.error('请输入不小于0的数字');
    } else {
      IPSService.maxCommission().then((res) => {
        // 格式化数据
        const commission = Number((Number(item.commission) * 100).toFixed(4));
        if (Number((item.commission / item.originPrice) * 100).toFixed(4) <= Number(res.maxCommission / 100).toFixed(4)) {
          const postParams = {
            pcId: item.pcId,
            commission,
          };
          IPSService.guiderProductCommissionSave({ postParams }).then((res) => {
            if (res) {
              this.$message.success('保存成功');
              this.getGoodsList(); // 获取商品列表
            } else {
              this.$message.error('保存失败');
            }
          });
        } else {
          this.$message.error(`保存失败,超过阈值:${res.maxCommission / 100}%`);
        }
      });
    }
  }

  /**
   * 删除分销商品
   * @param {number} id
   * @return null
   */
  public onDeleteGoods(id: number): void {
    this.$confirm('确认删除？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then(() => {
      const postParams = {
        pcId: `${id}`,
      };
      IPSService.guiderProductCommissionRemove({ postParams }).then((res) => {
        if (res) {
          this.$message.success('删除成功');
          this.getGoodsList(); // 获取商品列表
        } else {
          this.$message.error('删除失败');
        }
      });
    });
  }

  /**
   * 批量删除分销商品
   * @return null
   */
  public onDeleteGoodsMult(): void {
    this.$confirm('确认批量删除？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then(() => {
      const idList = [];
      this.selectedList.forEach((item) => {
        idList.push(item.pcId);
      });
      const postParams = {
        pcId: idList.join('|'),
      };
      IPSService.guiderProductCommissionRemove({ postParams }).then((res) => {
        if (res) {
          this.$message.success('删除成功');
          this.getGoodsList(); // 获取商品列表
        } else {
          this.$message.error('删除失败');
        }
      });
    });
  }

  get exportParams() {
    return {
      keywords: this.keywords, // 查询关键字（货号等）
    };
  }

  /**
   * 连接socket 生成消息体
   * @return null
   */
  public onSokectConnect(): void {
    this.$socket.emit('login', `${appEnvConfig.NODE_ENV}DistributeManage${this.$store.state.empCode}`); // 发送信息给服务端
    this.sockets.subscribe('new_msg', (msg) => {
      // 接收服务端的信息
      if (msg) {
        const msgArr = msg.split('|');
        const qiniuUrl = msgArr[3];
        console.log('msgArr====================', msgArr);
        if (msgArr[0] === 'success') {
          // 导出
          if (msgArr[msgArr.length - 2] === '1') {
            this.exportBtnInfo = {
              state: 2,
              url: qiniuUrl || `${Functions.ipsHostUrlApi()}/file/download?fileUrl=${msgArr[1]}`,
            };
            // 导入
          } else {
            this.successNum = msgArr[1];
            this.totalNum = msgArr[2];
            this.isImportPrepare = false;
            this.importState = 2;
            // }
            this.getGoodsList(); // 获取商品列表
          }
        } else if (msgArr[0] === 'fail') {
          this.$message.error('生成EXCEL失败');
        } else {
          if (msgArr[msgArr.length - 1] === '1') {
            this.exportBtnInfo = {
              state: 0,
              url: '',
            };
          } else {
            // 这边和成功返回的数据格式不一致，就先不显示了
            // this.successNum = msgArr[1];
            // this.totalNum = msgArr[2];
            this.failedNum = msgArr[2];
            this.isImportPrepare = false;
            this.importState = 2;
            this.failResultFileURl = qiniuUrl || `${Functions.ipsHostUrlApi()}/file/download?fileUrl=${msgArr[1]}`;
          }
        }
      }
    });
  }

  /**
   * 文件上传之前
   * @return {boolean}
   */
  public onFileBeforeUpload(file): boolean {
    // 判断文件类型
    const extensionArr = file.name.split('.');
    const extension = extensionArr[extensionArr.length - 1];
    const fileSize = file.size / 1024 / 1024;
    if (extension != 'xlsx') {
      this.$message.warning('模板只能是csv文件');
      return;
    }
    if (fileSize > 30) {
      this.$message.warning('文件不能大于30Mb');
      return;
    }
    this.files = file;
    this.fileName = file.name;
    return false; // 防止自动提交
  }

  /**
   * 把选中的文件上传到服务器
   * @return null
   */
  public onSubmitUpLoadedFile(): void {
    if (this.fileName === '') {
      this.$message.warning('请选择要上传的文件');
      return;
    }
    this.importState = 1;
    this.isImportPrepare = true;
    // 格式化表单数据
    const fileFormData = new FormData();
    fileFormData.append('sendToId', `${appEnvConfig.NODE_ENV}DistributeManage${this.$store.state.empCode}`);
    fileFormData.append('file', this.files, this.fileName); // filename是键，file是值，就是要传的文件，test是要传的文件名
    axios({
      url: `nips/admin/v/guider/product/commission/import?corpId=${this.corpId}`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': this.tokenData,
      },
      data: fileFormData,
    })
      .then()
      .catch((err) => {
        console.log(err);
      });
    // 清空数据
    this.files = null;
    this.fileName = '';
  }

  /**
   * 导入弹窗隐藏
   * @return null
   */
  public onImportFileDialogHide(): void {
    this.isImportPopShow = false;
    this.importState = 0;
    this.failResultFileURl = '';
    this.exportBtnInfo = {
      state: 0,
      url: '',
    };
    this.successNum = '0';
    this.failedNum = '0';
    this.totalNum = '0';
  }

  /**
   * 下载模板
   * @type {boolean} type
   * @return null
   */
  public onDownLoadExample(isBlank: boolean): void {
    location.href = `../../../static/files/${isBlank ? 'example-blank' : 'example'}.xlsx`;
  }

  /**
   * 下载导入结果
   * @return null
   */
  public onDownLoadFailRes(): void {
    location.href = this.failResultFileURl;
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-DISTRIBUTE-GOODS');
    if (this.isContentBodyShow) {
      this.getGoodsList(); // 获取商品列表
      setTimeout(() => {
        console.log('socket建立连接');
        this.$socket.connect(); // socket建立连接
        this.onSokectConnect(); // 打开socket
      }, 0);
      // 由于socket重新连接需要时间，所以延迟
      setTimeout(() => {
        this.isSocketReady = true;
      }, 1500);
    }
  }

  /**
   * 当组建即将销毁时
   * @return null
   */
  public beforeDestroy() {
    this.sockets.unsubscribe('new_msg'); // 取消订阅
    this.$socket.disconnect(); // 断开连接
  }
}
